import React, { useEffect, useMemo } from 'react';
import { Box } from '@common-fe/common-fe';

import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';

import AllocateFundsToTheAccount from './AllocateFundsToTheAccount';
import SelectEmployee from './SelectEmployee';

const AllocateFullCheck = () => {
  const { editableLockbox, setEditableLockbox } = useLockboxDetailsStore();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const defaultEmployee = useMemo(() => editableLockbox?.employeeId, []);

  useEffect(() => {
    return () => {
      setEditableLockbox({ employeeId: defaultEmployee, remainder: undefined });
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box height={{ min: '300px' }}>
      <SelectEmployee />
      <Box margin={{ top: 'spacing12' }}>
        <AllocateFundsToTheAccount />
      </Box>
    </Box>
  );
};

export default AllocateFullCheck;
